<template>
  <div class="ticheng-form-wrap">
    <div class="yeji-form">
      <div class="yj-label">
        方案名称：
      </div>
      <div class="yj-value">
        <template v-if="ruleDetail.detail">{{ ruleDetail.detail.ruleName }}</template>
      </div>
    </div>

    <div class="yeji-form">
      <div class="yj-label">
        提成计算类型：
      </div>
      <div class="yj-value">
        <template v-if="ruleDetail.detail">
          <template v-if="ruleDetail.detail.calKind == 1">
            每单计算
          </template>
          <template v-if="ruleDetail.detail.calKind == 2">
            阶段式计算
          </template>
          <template v-if="ruleDetail.detail.calKind == 3">
            阶梯式计算
          </template>
        </template>

      </div>
    </div>
    <div class="yeji-form ">
      <div class="yj-label">
        提成规则配置：
      </div>
      <div class="yj-value peizhi-value">
        <div class="titles">
          <div class="num">序号</div>
          <div>品类</div>
          <div class="price">提成类型</div>
          <div class="price">提成金额</div>
          <div>操作</div>
        </div>
        <div class="peizhi-list">
          <template v-if="guizePeizhiForm.length > 0">
            <template :key="item"
              v-for="(item, index) in $route.query.ruleKind == 1 || $route.query.ruleKind == 3 ? serveCategoryList : cardCategoryList">
              <div class="item">
                <div class="num">{{ index + 1 }}</div>
                <div>{{ item.kindName }}</div>
                <div class="price">
                  <el-select size="small" v-model="guizePeizhiForm[index].tctype" class="m-2" placeholder="提成类型">
                    <el-option v-for="item in tichengType" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                  <!-- {{ guizePeizhiForm[index].tctype == 1 ? '固定' : '百分比' }} -->
                </div>
                <div class="price">
                  <el-input size="small" v-model="guizePeizhiForm[index].tcprice" placeholder="提成金额">
                    <template #suffix>

                      <template v-if="guizePeizhiForm[index].tctype == 2">
                        | %
                      </template>
                      <template v-else>
                        | 元
                      </template>
                    </template>
                  </el-input>
                </div>
                <div>
                  <el-button @click="handleProductSetting(item.kindId)" size="small" plain>特殊产品设置
                    ({{ (tesuForm.filter(ele => ele.cid == item.kindId && String(ele.tctype).length > 0 &&
                        String(ele.tcprice).length > 0)).length
                    }})
                  </el-button>
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>


    <div v-if="countType == 2" class="yeji-form ">
      <div class="yj-label">
        阶段区间配置：
      </div>
      <div class="yj-value jd-peizhi-value">
        <div class="titles">
          <div class="num">序号</div>
          <div class="qujian">业绩区间</div>
          <div class="type">提成类型</div>
          <div class="price">提成金额</div>
          <div class="opt"></div>
        </div>

        <div class="peizhi-list">
          <template :key="item" v-for="(item, index) in jiduanListForm">
            <jieduanForm @handelRemoveClick="handelRemoveClick" @handelAddClick="handelAddClick" :index="index"
              :item="item"></jieduanForm>
          </template>
        </div>
      </div>
    </div>

    <div v-if="countType == 3" class="yeji-form ">
      <div class="yj-label">
        阶梯式区间配置：
      </div>
      <div class="yj-value jd-peizhi-value">
        <div class="titles">
          <div class="num">序号</div>
          <div class="qujian">业绩区间</div>
          <div class="type">提成类型</div>
          <div class="price">提成金额</div>
          <div class="opt"></div>
        </div>

        <div class="peizhi-list">
          <template :key="item" v-for="(item, index) in jietiForm">
            <jietiForm @handelRemoveClick="jietiRemoveClick" @handelAddClick="jietiAddClick"
              :isLast="index == jietiForm.length - 1" :index="index" :item="item"></jietiForm>
          </template>
        </div>
      </div>
    </div>

    <div class="yeji-form">
      <div class="yj-label">

      </div>
      <div class="yj-value save-from">
        <el-button @click="handleSaveClick" size="large" color="#2A82E4" type="primary">保存方案</el-button>
        <el-button @click="handlePreviousClick" plain size="large">返回上一步</el-button>
      </div>
    </div>
    <distribute @handleSaveClick='handleDistributeSaveClick' :tesuForm="tesuForm" :detailRes="ruleDetail"
      v-if="dialogVisible" @changeRuleForm='changeRuleForm' :cid="currentCid" @changeDialogVisible="changeDialogVisible"
      :dialogVisible="dialogVisible"></distribute>
  </div>
</template>

<script lang="js">
import { defineComponent, reactive, ref, watch } from 'vue'
import { tichengType } from './config'
import jieduanForm from './cpns/jieduan-form/jieduan-form'
import jietiForm from './cpns/jieti-form/jieti-form.vue'
import distribute from './cpns/distribute-dialog/distribute-dialog.vue'
import { useRoute } from 'vue-router'
import { getServeCategoryList, addRuleSaveRule, updateRuleServe, updateRuleJieDuan, getRuleDetail } from '@/service/main/commission'
import { COMPANY_ID } from '@/common/constant'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'



export default defineComponent({
  props: {
    countType: {
      type: Number,
      required: true
    },
    ruleId: {
      type: Number,
      default: -1
    },
    addRuleInfo: {
      type: Object,
      required: true
    }
  },
  components: {
    jieduanForm,
    jietiForm,
    distribute
  },
  setup(props, { emit }) {
    const route = useRoute()
    const router = useRouter()

    const jiduanListFormList = ref([])
    const jiduanListForm = ref([])

    const handelAddClick = () => {
      jiduanListForm.value.push({
        yjstart: '',
        yjend: '',
        tctype: '',
        tcprice: '',
      })
    }



    const jietiForm = ref([
      {
        yjstart: '',
        yjend: '',
        tctype: '',
        tcprice: '',
      },
      {
        yjstart: '',
        yjend: '',
        tctype: '',
        tcprice: '',
      }
    ])
    const cardCategoryList = ref([
      {
        kindName: '有限次卡',
        kindId: 3
      }, {
        kindName: '不限次卡',
        kindId: 4
      },
      {
        kindName: '储值卡',
        kindId: 5
      }
    ])
    const rulePeizhiForm = ref([])

    const handelRemoveClick = (index) => {
      jiduanListForm.value.splice(index, 1)
    }

    const jietiRemoveClick = (index) => {
      jietiForm.value.splice(index, 1)
    }

    const handlePreviousClick = () => {
      emit('previousClick')
    }

    const jietiAddClick = () => {
      jietiForm.value.push({
        yjstart: '',
        yjend: '',
        tctype: '',
        tcprice: '',
        ruleId: route.query.ruleId,
        ruleKind: route.query.ruleKind == 1 || route.query.ruleKind == 3 ? 1 : 2
      })
    }


    const guizePeizhiFormList = ref([])
    const tesuFormList = ref([])
    const jietiFormList = ref([])
    const handleSaveClick = async () => {
      guizePeizhiFormList.value = []
      tesuFormList.value = []
      jiduanListFormList.value = []
      jietiFormList.value = []
      let flag1 = true, flag2 = true, flag3 = true;

      guizePeizhiForm.value.forEach(item => {
        let flag = true
        for (let key in item) {
          if (String(item[key]).length == 0) {
            flag = false
            flag1 = false
            break;
          }
        }
        if (flag) {
          guizePeizhiFormList.value.push(item)
        }
      })

      if (flag1 == false) {
        ElMessage({
          message: '请完整填写提成规则配置!',
          type: 'warning',
        })
        return
      }



      let ruleKind = route.query.ruleKind
      if (ruleKind == 1 || ruleKind == 3) {
        let specServes = ruleDetail.value.specServes
        specServes.forEach(item => {
          let index = tesuForm.value.findIndex(ele => ele.serveId == item.serveId && ele.cid == item.cataId)
          if (index == -1) {
            tesuForm.value.push({
              serveId: item.serveId,
              tctype: item.kind,
              tcprice: item.qty,
              cid: item.cataId
            })

          }
        })
      } else {
        let specCards = ruleDetail.value.specCards
        specCards.forEach(item => {
          let index = tesuForm.value.findIndex(ele => ele.serveId == item.itemId && ele.cid == item.cataId)
          if (index == -1) {
            tesuForm.value.push({
              serveId: item.itemId,
              tctype: item.kind,
              tcprice: item.qty,
              cid: item.cataId
            })
          }
        })
      }


      tesuForm.value.forEach(item => {
        let flag = true
        for (let key in item) {
          if (String(item[key]).length == 0) {
            flag = false
            break;
          }
        }
        if (flag) {
          tesuFormList.value.push(item)
        }
      })

      jiduanListForm.value.forEach(item => {
        let flag = true
        for (let key in item) {
          if (String(item[key]).length == 0) {
            flag = false
            flag2 = false
            break;
          }
        }
        if (flag) {
          jiduanListFormList.value.push(item)
        }
      })


      if (flag2 == false && props.countType == 2) {
        ElMessage({
          message: '请完整填写阶段式区间配置!',
          type: 'warning',
        })
        return
      }




      if (jietiForm.value.length > 2) {
        jietiForm.value[0].yjstart = '0'
        jietiForm.value[jietiForm.value.length - 1].yjend = '0'
        jietiForm.value.forEach(item => {
          let flag = true
          for (let key in item) {
            if (String(item[key]).length == 0) {
              flag = false
              break;
            }
          }
          if (flag) {
            jietiFormList.value.push(item)
          }
        })
      } else {
        jietiForm.value[0].yjstart = '0'
        jietiForm.value[jietiForm.value.length - 1].yjend = '0'
        jietiFormList.value = jietiForm.value
      }

      let obj = {
        ruleId: route.query.ruleId,
        cataStr: [],
        specStr: [],
        ruleKind: route.query.ruleKind == 1 || route.query.ruleKind == 3 ? 1 : 2,
        itemkind: route.query.ruleKind == 1 || route.query.ruleKind == 3 ? '' : 1
      }
      guizePeizhiFormList.value.forEach(item => {
        // console.log(item);
        obj.cataStr.push(`${item.cid},${item.tctype},${item.tcprice}`)
      })

      tesuFormList.value.forEach(item => {
        // console.log(item);
        obj.specStr.push(`${item.cid},${item.serveId},${item.tctype},${item.tcprice}`)
      })

      obj.cataStr = obj.cataStr.join('&')
      obj.specStr = obj.specStr.join('&')

      let res = await updateRuleServe(obj)

      let flag = true
      if (res.code != 0) {
        flag = false
      }

      if (props.countType == 2) {
        let obj = {
          ruleId: route.query.ruleId,
          companyId: COMPANY_ID,
          rangeStr: [],
          calKind: 1
        }
        jiduanListFormList.value.forEach(item => {
          obj.rangeStr.push(`${item.yjstart},${item.yjend},${item.tctype},${item.tcprice}`)
        })
        obj.rangeStr = obj.rangeStr.join('&')
        const res = await updateRuleJieDuan(obj)
        if (res.code != 0) {
          flag = false
        }
      }



      jietiForm.value.forEach(item => {
        for (let key in item) {
          if (String(item[key]).length == 0) {
            flag3 = false
            break;
          }
        }
      })

      if (flag3 == false && props.countType == 3) {
        ElMessage({
          message: '请完整填写阶梯式区间配置!',
          type: 'warning',
        })
        return
      }


      if (props.countType == 3) {

        let obj = {
          ruleId: route.query.ruleId,
          companyId: COMPANY_ID,
          rangeStr: [],
          calKind: 2
        }

        jietiFormList.value[0].yjstart = 0
        jietiFormList.value[(jietiFormList.value.length) - 1].yjend = 0
        jietiFormList.value.forEach(item => {
          obj.rangeStr.push(`${item.yjstart},${item.yjend},${item.tctype},${item.tcprice}`)
        })
        obj.rangeStr = obj.rangeStr.join('&')
        const res = await updateRuleJieDuan(obj)
        if (res.code != 0) {
          flag = false
        }
      }


      if (flag) {
        ElMessage({
          message: '操作成功',
          type: 'success',
        })
        router.push('/main/commission/list')
      } else {
        ElMessage.error('操作失败,请刷新')
      }
    }





    const dialogVisible = ref(false)
    const changeDialogVisible = (flag) => {
      dialogVisible.value = flag
    }


    const currentCid = ref('')
    const handleProductSetting = (cid) => {
      // console.log(cid);
      currentCid.value = cid
      dialogVisible.value = true
    }


    const serveCategoryList = ref([])
    const guizePeizhiForm = ref([])
    const ruleDetail = ref([])
    const initPage = async () => {
      let res
      const detailRes = await getRuleDetail(COMPANY_ID, route.query.ruleId)
      ruleDetail.value = detailRes.data

      if (route.query.ruleKind == 1 || route.query.ruleKind == 3) {
        res = await getServeCategoryList({
          companyId: COMPANY_ID
        })
        let specServes = ruleDetail.value.specServes
        specServes.forEach(item => {
          let index = tesuForm.value.findIndex(ele => ele.serveId == item.serveId && ele.cid == item.cataId)
          if (index == -1) {
            tesuForm.value.push({
              serveId: item.serveId,
              tctype: item.kind,
              tcprice: item.qty,
              cid: item.cataId
            })
          }
        })

      } else {
        res = {
          data: {
            serveCata: [
              {
                tcprice: '',
                tctype: '',
                kindId: 3
              },
              {
                tcprice: '',
                tctype: '',
                kindId: 4
              }, {
                tcprice: '',
                tctype: '',
                kindId: 5
              }

            ]
          }
        }

        let specCards = ruleDetail.value.specCards
        specCards.forEach(item => {
          let index = tesuForm.value.findIndex(ele => ele.serveId == item.itemId && ele.cid == item.cataId)
          if (index == -1) {
            tesuForm.value.push({
              serveId: item.itemId,
              tctype: item.kind,
              tcprice: item.qty,
              cid: item.cataId
            })
          }
        })
      }


      guizePeizhiForm.value = []
      serveCategoryList.value = res.data.serveCata
      serveCategoryList.value.forEach(item => {
        guizePeizhiForm.value.push({
          tcprice: '',
          tctype: '',
          cid: item.kindId
        })
      })

      let peizhiList = ruleDetail.value.catas
      peizhiList.forEach((item, index) => {
        guizePeizhiForm.value[index].tctype = String(item.archkind)
        guizePeizhiForm.value[index].tcprice = item.qty
      })

      let jieduaList = ruleDetail.value.archRange
      if (jieduaList.length > 0) {
        if (detailRes.data.detail.calKind == 2) {
          jiduanListForm.value = []
          detailRes.data.archRange.forEach(item => {
            jiduanListForm.value.push({
              yjstart: item.rangemin,
              yjend: item.rangemax,
              tctype: item.kind,
              tcprice: item.qty
            })
          })

        } else if (detailRes.data.detail.calKind == 3) {
          jietiForm.value = []
          detailRes.data.archRange.forEach(item => {
            jietiForm.value.push({
              yjstart: item.rangemin,
              yjend: item.rangemax,
              tctype: item.kind,
              tcprice: item.qty
            })
          })
        }
      }



      // console.log(guizePeizhiForm.value);
    }
    initPage()



    const tesuForm = ref([])
    const changeRuleForm = (list) => {
      list.forEach(item => {
        // console.log(tesuForm.value);
        const index = tesuForm.value.findIndex(ele => ele.serveId == item.serveId)

        if (index == -1) {
          tesuForm.value.push(item)
        } else {
          tesuForm.value[index].tcprice = item.tcprice
          tesuForm.value[index].tctype = item.tctype
        }
      })

    }



    const handleDistributeSaveClick = () => {
      dialogVisible.value = false
    }
    return {
      handleDistributeSaveClick,
      cardCategoryList,
      jietiFormList,
      jiduanListFormList,
      tesuFormList,
      guizePeizhiFormList,
      tesuForm,
      changeRuleForm,
      currentCid,
      dialogVisible,
      changeDialogVisible,
      handleProductSetting,
      jietiRemoveClick,
      jietiAddClick,
      handlePreviousClick,
      tichengType,
      jiduanListForm,
      handelAddClick,
      handelRemoveClick,
      jietiForm,
      serveCategoryList,
      guizePeizhiForm,
      handleSaveClick,
      ruleDetail
    }

  }
})
</script>

<style scoped lang="less">
.ticheng-form-wrap {
  padding-bottom: 82px;

  .yeji-form-center {
    align-items: center;
  }



  .yeji-form {
    display: flex;
    margin-bottom: 27px;
    font-size: 14px;

    .yj-label {
      width: 120px;
      font-weight: bold;
      color: rgba(80, 80, 80, 1);

    }

    .yj-value {
      flex: 1;

    }

    .jd-peizhi-value {
      max-width: 700px;

      .titles {
        display: flex;
        height: 36px;
        line-height: 36px;
        color: rgba(80, 80, 80, 1);
        background-color: rgba(239, 239, 239, 1);
        font-size: 14px;
        padding: 0 18px;

        .num {
          flex: .6;
        }

        .qujian {
          flex: 2;
        }

        .type {
          flex: 1.2;
        }

        .price {
          flex: 1.2;
        }

        .opt {
          flex: .8;
        }
      }
    }

    .peizhi-value {
      max-width: 700px;

      &:deep(.el-select) {
        max-width: 120px;
      }

      &:deep(.el-input) {
        max-width: 120px;
      }

      .peizhi-list {


        .item {
          display: flex;
          line-height: 60px;
          height: 60px;
          border-bottom: 1px solid rgba(204, 204, 204, .6);
          padding: 0 18px;

          .num {
            flex: .6;
          }

          &>div {
            flex: 1;
          }

          .price {
            flex: 1.4;
          }
        }
      }

      .titles {
        display: flex;
        height: 36px;
        line-height: 36px;
        color: rgba(80, 80, 80, 1);
        background-color: rgba(239, 239, 239, 1);
        font-size: 14px;
        padding: 0 18px;

        .num {
          flex: .6;
        }

        .price {
          flex: 1.4;
        }

        &>div {
          flex: 1;
        }
      }
    }

    .save-from {
      display: flex;
      align-items: center;
      margin-top: 64px;

      &:deep(.el-button) {
        width: 213px;
        height: 48px;
      }

      .tips {
        color: rgba(153, 153, 153, 1);
        font-size: 14px;
        margin-left: 19px;
      }
    }


  }
}
</style>




